import { createContext, useContext, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LANGS = [
  { code: "en", label: "EN" },
  { code: "zh", label: "中文" },
  { code: "es", label: "ES" },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("elite_lang") || "en");
  const setLang = (code) => {
    localStorage.setItem("elite_lang", code);
    setLangState(code);
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
